// extracted by mini-css-extract-plugin
export default {"root":"UserAvatar_root__st0-i","avatar":"UserAvatar_avatar__rvjDm","info":"UserAvatar_info__-aLkH","username":"UserAvatar_username__+QNga","address":"UserAvatar_address__uxsgl"};